import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";
import adminApiClient, {
  DeleteUserOptions,
  DeleteUserResult,
} from "../../../../api/admin";

export type DeleteUserVariables = {
  userId: string;
  options?: DeleteUserOptions;
};

const useDeleteUserMutation = (
  options: UseMutationOptions<
    DeleteUserResult,
    Error,
    DeleteUserVariables,
    unknown
  > = {},
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["deleteUser"],
    mutationFn: async ({
      userId,
      options: deleteOptions,
    }: DeleteUserVariables) => {
      return adminApiClient.deleteUser(userId, deleteOptions);
    },
    onSuccess: (
      data: DeleteUserResult,
      variables: DeleteUserVariables,
      context: unknown,
    ) => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
      // Also drop this user's cached content so a re-open (e.g. after a partial
      // failure) never shows already-deleted klydos/collections.
      queryClient.invalidateQueries({
        queryKey: ["userContent", variables.userId],
      });
      options?.onSuccess?.(data, variables, context);
    },
    ...options,
  });
};
export default useDeleteUserMutation;
